// Human-readable labels for the canonical ingress `source` values (+ legacy).
// Mirrors backend project/utils/ingress.py. Unknown values render as-is.

const INGRESS_SOURCE_LABELS: Record<string, string> = {
  DSA_SHARE: "DSA Agent Share",
  PARTNER_REDIRECT: "Partner Redirect",
  MARKETING_CAMPAIGN: "Marketing",
  DIRECT_WEBAPP: "Direct (Web App)",
  WEBSITE_LANDING: "Website",
  ADMIN_GENERATED: "Admin",
  DIRECT_IOS_APP: "iOS App",
  DIRECT_ANDROID_APP: "Android App",
  MIS_BACKFILL: "MIS (offline)",
  DSA_PARTNER_REDIRECT: "Untagged link (legacy)",
  // legacy stored values still seen on old rows
  ORGANIC_APP: "Organic App (legacy)",
  CHANNEL: "Admin (legacy)",
  UTM_LINK: "DSA Agent Share (legacy)",
  PROVIDER_LINK: "Partner Redirect (legacy)",
};

export function ingressSourceLabel(value: unknown): string {
  const v = (value == null ? "" : String(value)).trim();
  if (!v) return "-";
  if (INGRESS_SOURCE_LABELS[v]) return INGRESS_SOURCE_LABELS[v];
  // legacy dynamic vendor-suffixed values
  if (v.startsWith("AGENT_")) return "DSA Agent (legacy)";
  if (v.startsWith("PORTAL_")) return "Organic App (legacy)";
  return v;
}
